
import { Router } from "@reach/router";
import React, { useState, useRef, useEffect, ReactElement } from "react";
import { connect } from "react-redux";
import { Configuration, InteractionRequiredAuthError, UserAgentApplication } from "msal";
import * as AuthActions from '../../store/actions/authActions';
import {config} from "config";


const configOauth: Configuration = {
    auth: {
      authority:  config.REACT_APP_OAUTH_AUTHORITY,
      clientId: config.REACT_APP_OAUTH_CLIENT_ID,
      postLogoutRedirectUri: window.location.origin,
      redirectUri: window.location.origin,
      validateAuthority: true,
      // After being redirected to the "redirectUri" page, should user
      // be redirected back to the Url where their login originated from?
      navigateToLoginRequestUrl: true,
    },
    cache: {
      cacheLocation:"localStorage",
      storeAuthStateInCookie: true,
    },
  };
  
  // Authentication Parameters
  const authenticationParameters = {
    scopes: [config.REACT_APP_OAUTH_SCOPE_BACKEND_API],
  };

const msalClient = new UserAgentApplication(configOauth);

function AuthProvider({ children, name, setIdToken, setAccessToken }: any) {
    const [firstTime, setFirstTime] = useState(true);
    const [authError, setAuthError] = useState<string | null>(null);
    const loginInProgress = useRef(false);

    function getAuthParameters() {
        const account = msalClient.getAccount();
        if (!account) {
            return authenticationParameters;
        }

        return {
            ...authenticationParameters,
            account,
            loginHint: account.userName,
        };
    }

    function setIdentityFromAccount() {
        const account = msalClient.getAccount();
        if (!account) {
            return;
        }

        setIdToken({
            idToken: {
                name: account.name,
                preferredName: account.userName,
            },
        });
    }

    function AuthenticationProcess(){
        console.log('[AUTH] Starting authentication process...');
        console.log('[AUTH] Config:', {
            authority: config.REACT_APP_OAUTH_AUTHORITY,
            clientId: config.REACT_APP_OAUTH_CLIENT_ID,
            scope: config.REACT_APP_OAUTH_SCOPE_BACKEND_API
        });

        if (msalClient.getAccount()) {
            console.log('[AUTH] Account found in cache');
            setIdentityFromAccount();
            GetAccessToken();
            return;
        }

        startInteractiveLogin();
    }

    function startInteractiveLogin() {
        if (loginInProgress.current) {
            return;
        }

        loginInProgress.current = true;
        console.log('[AUTH] Starting interactive login (popup)...');
        msalClient.loginPopup(getAuthParameters())
            .then(() => {
                setIdentityFromAccount();
                GetAccessToken();
            })
            .catch((error) => {
                console.error('[AUTH] Interactive login failed:', error);
                setAuthError(error.message || 'Authentication failed');
            })
            .finally(() => {
                loginInProgress.current = false;
            });
    }

    function GetAccessToken(){
        console.log('[AUTH] Getting access token (popup)...');
        msalClient.acquireTokenPopup(getAuthParameters())
        .then((accessToken) =>
        {
            console.log('[AUTH] Access token received successfully');
            setAccessToken({ accessToken: accessToken.accessToken });
            setFirstTime(false);
            setAuthError(null);
        })
        .catch((error) =>
        {
            console.error('[AUTH] Error getting access token:', error);
            setAuthError(error.message || 'Failed to get access token');

            if (error instanceof InteractionRequiredAuthError) {
                startInteractiveLogin();
            }
        });
    }

    useEffect(() => {
        if (firstTime){
            AuthenticationProcess();
        }
    }, [firstTime]);

    return (
        <>
            {authError && (
                <div style={{
                    position: 'fixed',
                    top: 20,
                    left: '50%',
                    transform: 'translateX(-50%)',
                    backgroundColor: '#f44336',
                    color: 'white',
                    padding: '15px 30px',
                    borderRadius: '4px',
                    zIndex: 9999,
                    boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
                    maxWidth: '80%',
                    textAlign: 'center'
                }}>
                    <strong>Erreur d'authentification:</strong> {authError}
                    <br />
                    <small>Redirection vers la page de connexion...</small>
                </div>
            )}
            <Router>
                {children}
            </Router>
        </>
    );
}


const mapStateToProps = (state: any) => {
    return {
        name: state.authentReducer.name,
    };
};

const mapDispatchToProps = {
    setIdToken: AuthActions.SetIdToken,
    setAccessToken: AuthActions.SetAccessToken
}

export default connect(mapStateToProps, mapDispatchToProps)(AuthProvider);

